/**
 * Framer Motion presets aligned with motion tokens in globals.css (README §3).
 */

import type { Transition } from "framer-motion";

const reduced: Transition = { duration: 0.01 };

export const transitions: Record<
  "micro" | "context" | "route" | "ceremonial",
  Transition
> = {
  micro: { duration: 0.12, ease: [0.2, 0.9, 0.2, 1] },
  context: { duration: 0.22, ease: [0.33, 1, 0.68, 1] },
  route: { duration: 0.4, ease: [0.33, 1, 0.68, 1] },
  ceremonial: { duration: 0.85, ease: [0.7, 0, 0.84, 0] },
};

export function transitionOrReduced(
  prefersReducedMotion: boolean | null,
  t: Transition,
): Transition {
  if (prefersReducedMotion) return reduced;
  return t;
}
